const teKundli = {
  // Errors & validation
  "please_fill_required_fields": "దయచేసి అన్ని అవసరమైన వివరాలు పూరించండి.",
  "invalid_email_format": "దయచేసి సరైన ఇమెయిల్ చిరునామా నమోదు చేయండి.",
  "invalid_phone_format": "దయచేసి సరైన ఫోన్ నంబర్ నమోదు చేయండి.",
  "payment_failed_message": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి లేదా సహాయాన్ని సంప్రదించండి.",

  // Header & hero
  "cosmic_career": " కుండ్లీ రిపోర్ట్",
  "journey": "మీ సంపూర్ణ జీవిత విశ్లేషణ",
  "discover_professional_destiny": "వ్యక్తిగత వేద జ్యోతిష్య రిపోర్ట్ — కెరీర్, సంబంధాలు, ఆరోగ్యం మరియు పరిహారాలు — 24 గంటల్లో మీకు అందుతుంది.",

  // Form labels
  "full_name": "పూర్తి పేరు",
  "enter_complete_name": "మీ పూర్తి పేరును నమోదు చేయండి",
  "gender": "లింగం",
  "male": "పురుషుడు",
  "female": "స్త్రీ",
  "other": "ఇతరులు",
  "email_address": "ఇమెయిల్ చిరునామా",
  "email_placeholder": "meeru@email.com",
  "phone_number": "ఫోన్ నంబర్",
  "phone_placeholder": "+91 1234567890",
  "your_birth_date": "మీ జనన తేదీ",
  "birth_time": "జనన సమయం",
  "birth_place": "జనన స్థలం",
  "city_state_country": "నగరం, రాష్ట్రం, దేశం",
  "preferred_language": "ప్రాధాన్యభాష",
  "english": "🇺🇸 ఇంగ్లీష్",
  "hindi": "🇮🇳 హిందీ",
  "telugu": "🇮🇳 తెలుగు",
  "kannada": "🇮🇳 కన్నడ",
  "tamil": "🇮🇳 తమిళం",
  "marathi": "🇮🇳 మరాఠీ",
  "bengali": "🇮🇳 బెంగాలీ",

  // Benefits (what you'll receive)
  "what_youll_receive": "మీకు లభించేది",
  "life_kundali_20_years": "సమగ్ర కుండ్లీ — కెరీర్, సంబంధాలు, ఆరోగ్యం మరియు ఆర్థిక రంగాలలో దీర్ఘకాల మార్గదర్శకత్వం.",
  "detailed_career_path_analysis": " PDF — చార్ట్‌లు, యోగాలు, దశలు, గోచారాలు మరియు విజువల్ వివరణలతో.",
  "planetary_position_interpretations": "గ్రహాల స్థానాలు మరియు భవనాల స్పష్టమైన విశ్లేషణ — సులభంగా చదివే రీతిలో.",
  "dasha_system_predictions": "దశలు మరియు గోచారాల ఆధారంగా సమయ సూచనలు — సరైన నిర్ణయాలకు మార్గదర్శకత్వం.",
  "personalized_remedial_suggestions": "వ్యక్తిగత పరిహారాలు మరియు రత్న సిఫారసులు — కష్టకాలాలను సమతుల్యం చేసుకోవడానికి.",
  "digital_pdf_report": "డిజిటల్ PDF — వాట్సాప్ లేదా ఇమెయిల్ ద్వారా 24 గంటల్లో పంపబడుతుంది.",

  // Pricing/checkout
  "unlock_your_destiny_title": "మీ పూర్తి రిపోర్ట్ పొందండి",
  "complete_cosmic_journey_desc": "ఫారమ్ పూర్తి చేసి మీ వ్యక్తిగత  జ్యోతిష్య రిపోర్ట్ పొందండి.",
  "premium": "ప్రీమియం రిపోర్ట్",
  "career_path_analysis": "సంపూర్ణ జీవిత విశ్లేషణ రిపోర్ట్",
  "processing_payment": "చెల్లింపు ప్రాసెస్ అవుతోంది...",
  "preparing_analysis": "మీ  రిపోర్ట్ సిద్ధమవుతోంది...",
  "complete_payment_get_report": "🚀 చెల్లింపు పూర్తి చేసి రిపోర్ట్ పొందండి",

  // Trust indicators
  "reports_generated": "15,000+ రిపోర్టులు పంపించబడ్డాయి",
  "rating": "వినియోగదారుల రేటింగ్ 4.9/5",
  "secure": "🔒 సురక్షిత చెల్లింపు విధానం",

  // API / runtime messages
  "failed_to_load_payment": "చెల్లింపు గేట్‌వే లోడ్ కాలేదు. దయచేసి మళ్లీ ప్రయత్నించండి.",
  "failed_to_create_order": "ఆర్డర్ సృష్టించలేకపోయాము. మళ్లీ ప్రయత్నించండి.",
  "failed_to_initialize_payment": "చెల్లింపు ప్రారంభం విఫలమైంది. కొద్దిసేపటికి మళ్లీ ప్రయత్నించండి.",
  "failed_to_open_payment_gateway": "చెల్లింపు విండో ఓపెన్ కాలేదు. దయచేసి మళ్లీ ప్రయత్నించండి.",

  // Service details
  "birth_chart_analysis": "వ్యక్తిగత జ్యోతిష్య రిపోర్ట్",
  "complete_kundli_report": " వేద కుండ్లీ రిపోర్ట్ - జీవితంలోని అన్ని విభాగాలు",
  "service_amount": "₹599",

  "advanced_astrology_suite": "అడ్వాన్స్‌డ్ జ్యోతిష్య సూట్",
  "suite_summary": "కాలరేఖలు, అనుకూలత మరియు స్పష్టమైన విశ్లేషణలతో లోతైన జ్యోతిష్య రిపోర్ట్‌లు — సులభంగా చదవడానికి మరియు పంచుకోవడానికి సిద్ధంగా ఉంటాయి.",
  "feature_reports": "సమగ్ర రిపోర్ట్‌లు — స్పష్టమైన ఫార్మాటింగ్ మరియు విజువల్ విభాగాలతో.",
  "feature_compatibility": "అనుకూలత విశ్లేషణ మరియు కాలరేఖలు — ముఖ్య నిర్ణయాలకు తోడ్పడతాయి.",
  "feature_multilingual": "బహుభాషా రిపోర్ట్‌లు మరియు మొబైల్/పీసీకి అనుకూలమైన రూపకల్పన.",
  "report_preview_alt": "రిపోర్ట్ ప్రివ్యూ",
  "get_my_report": "నా రిపోర్ట్ పొందండి",
  "autocomplete_hint": "మీ నగరాన్ని టైప్ చేయడం ప్రారంభించండి; సూచనలు ఆటోమేటిక్‌గా కనిపిస్తాయి"
};
export default teKundli;


// const teKundli = {
//   // Error Messages
//   "please_fill_required_fields": "దయచేసి అవసరమైన అన్ని ఖాళీలను పూరించండి.",
//   "invalid_email_format": "దయచేసి సరైన ఇమెయిల్ చిరునామాను నమోదు చేయండి.",
//   "invalid_phone_format": "దయచేసి సరైన ఫోన్ నంబర్‌ను నమోదు చేయండి.",
//   "payment_failed_message": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి లేదా సహాయాన్ని సంప్రదించండి.",

//   // Step Configuration
//   "personal_identity": "వ్యక్తిగత సమాచారం",
//   "tell_us_about_yourself": "ప్రారంభించడానికి మీ గురించి చెప్పండి",
//   "birth_details": "జనన వివరాలు",
//   "your_cosmic_coordinates": "మీ విశ్లేషణను ప్రారంభించేందుకు మీ జనన వివరాలు అవసరం",
//   "time_and_place": "జనన సమయం & స్థలం",
//   "when_and_where_arrived": "ఎప్పుడు మరియు ఎక్కడ పుట్టారు?",
//   "your_preferences": "భాషా అభిరుచి",
//   "customize_experience": "నివేదికకు ఇష్టమైన భాషను ఎంచుకోండి",
//   "unlock_your_destiny": "మీ  జాతకం పొందండి",
//   "complete_cosmic_journey": "పూర్తి నివేదిక పొందటానికి మీ వివరాలు పూర్తి చేయండి",

//   // Step 0: Personal Details
//   "who_are_you": "మీరు ఎవరు?",
//   "start_with_basics": "మూల వివరాలతో ప్రారంభించండి",
//   "full_name": "పూర్తి పేరు",
//   "enter_complete_name": "పూర్తి పేరును నమోదు చేయండి",
//   "gender": "లింగం",
//   "male": "పురుషుడు",
//   "female": "స్త్రీ",
//   "other": "ఇతర",
//   "email_address": "ఇమెయిల్ చిరునామా",
//   "email_placeholder": "your@email.com",
//   "phone_number": "ఫోన్ నంబర్",
//   "phone_placeholder": "+91 1234567890",

//   // Step 1: Birth Date
//   "your_birth_date": "మీ జనన తేదీ",
//   "cosmic_journey_begin": "మీ ఖగోళ ప్రయాణం ఎప్పుడు ప్రారంభమైంది?",
//   "age_label": "వయస్సు",
//   "years": "సంవత్సరాలు",

//   // Step 2: Time & Place
//   "time_and_place_title": "జనన సమయం & స్థలం",
//   "precise_moment_location": "ఖచ్చితమైన సమయం మరియు స్థలం ఖచ్చితమైన లెక్కల కోసం అవసరం",
//   "birth_time": "జనన సమయం",
//   "select_exact_time": "ఖచ్చితమైన జనన సమయాన్ని ఎంచుకోండి",
//   "birth_place": "జన్మ స్థలం",
//   "city_state_country": "నగరం, రాష్ట్రం, దేశం",
//   "location_accuracy": "స్థాన ఖచ్చితత్వం",
//   "exact_birthplace_ensures": "ఖచ్చితమైన జన్మస్థలం గ్రహస్థితులను సరిగ్గా నిర్ధారిస్తుంది",

//   // Step 3: Preferences
//   "your_preferences_title": "భాష ఎంచుకోండి",
//   "customize_astrological_experience": "మీ వ్యక్తిగత నివేదికకు భాషను ఎంచుకోండి",
//   "preferred_language": "ఇష్టమైన భాష",
//   "english": "🇺🇸 ఇంగ్లీష్",
//   "hindi": "🇮🇳 హిందీ",
//   "telugu": "🇮🇳 తెలుగు",
//   "kannada": "🇮🇳 కన్నడ",
//   "tamil": "🇮🇳 తమిళం",
//   "marathi": "🇮🇳 మరాఠీ",
//   "bengali": "🇮🇳 బెంగాలీ",
//   "what_youll_receive": "మీకు లభ్యమయ్యేవి",
//   "life_kundali_20_years": "20 సంవత్సరాల భవిష్య సూచనలతో జీవిత జాతకం — వృత్తి, ప్రేమ, ఆరోగ్యం & సంపదకు ప్రతి సంవత్సర మార్గదర్శకం",
//   "detailed_career_path_analysis": " PDF జాతక నివేదిక",
//   "planetary_position_interpretations": "20+ జ్యోతిష్య వ్యవస్థలను కవర్ చేస్తుంది",
//   "dasha_system_predictions": "వృత్తి, వివాహం, ఆరోగ్యం & జీవిత సూచనలు సమావేస్తుంది",
//   "personalized_remedial_suggestions": "వ్యక్తిగత పరిహారాలు & రత్నాల సూచనలు",
//   "digital_pdf_report": "24 గంటల్లో WhatsApp లేదా ఇమెయిల్ ద్వారా అందజేత",

//   // Step 4: Payment
//   "unlock_your_destiny_title": "మీ పూర్తి నివేదిక పొందండి",
//   "complete_cosmic_journey_desc": "ఫారమ్‌ను పూర్తి చేసి మీ వ్యక్తిగత  జ్యోతిష్య నివేదిక పొందండి",
//   "premium": "ప్రీమియం నివేదిక",
//   "career_path_analysis": "సంపూర్ణ జీవిత విశ్లేషణ నివేదిక",
//   "off_label": "తగ్గింపు",
//   "summary_of_details": "మీ సారాంశం:",
//   "name_label": "పేరు:",
//   "birth_date_label": "జనన తేదీ:",
//   "birth_time_label": "జనన సమయం:",
//   "birth_place_label": "జన్మ స్థలం:",
//   "processing_payment": "చెల్లింపును ప్రాసెస్ చేస్తున్నారు...",
//   "preparing_analysis": "మీ  నివేదికను సృష్టిస్తున్నారు...",
//   "complete_payment_get_report": "🚀 చెల్లింపు పూర్తి చేసి నివేదిక పొందండి",

//   // Navigation
//   "previous": "← మునుపటి",
//   "step_of": "దశ",
//   "of": "లో",
//   "next": "తదుపరి →",
//   "review_and_pay": "సమీక్షించి చెల్లించండి",

//   // Validation Messages
//   "fill_personal_details": "దయచేసి అవసరమైన వ్యక్తిగత వివరాలు పూరించండి",
//   "select_birth_date": "దయచేసి మీ జనన తేదీని ఎంచుకోండి",
//   "provide_birth_time_place": "దయచేసి ఖచ్చితమైన జనన సమయం మరియు స్థలాన్ని ఇవ్వండి",

//   // Header
//   "cosmic_career": " జాతక నివేదిక",
//   "journey": "మీ సంపూర్ణ జీవిత విశ్లేషణ",
//   "discover_professional_destiny": "వృత్తి, ప్రేమ, ఆరోగ్యం, పరిహారాలతో మీ వ్యక్తిగత వేద జ్యోతిష్య నివేదిక—24 గంటల్లో అందజేస్తాం. 20 సంవత్సరాల భవిష్య సూచనలతో జీవిత జాతకం — వృత్తి, ప్రేమ, ఆరోగ్యం & సంపదకు ప్రతి సంవత్సర మార్గదర్శకం",

//   // Trust Indicators
//   "reports_generated": "15,000+ నివేదికలు అందించబడ్డాయి",
//   "rating": "వినియోగదారుల రేటింగ్ 4.9/5",
//   "secure": "🔒 సురక్షిత చెల్లింపు",

//   // Thank You Page Service Features
//   "detailed_career_guidance_pdf": "సంపూర్ణ వృత్తి & జీవిత మార్గదర్శకం",
//   "comprehensive_astrological_analysis": "20+ జ్యోతిష్య వ్యవస్థల ఆధారంగా",
//   "planetary_positions_interpretations": "దశా, గోచార, నక్షత్రం, అంక శాస్త్రం",
//   "dasha_system_predictions_feature": "భవిష్య సూచనలు, గ్రహాల కాలరేఖలు",
//   "personalized_remedial_suggestions_feature": "అనుకూల పరిహారాలు, రత్నాలు & దోష నివేదికలు",

//   // API Related Messages
//   "failed_to_load_payment": "చెల్లింపు గేట్‌వే లోడ్ కాలేదు. దయచేసి మళ్లీ ప్రయత్నించండి.",
//   "failed_to_create_order": "ఆర్డర్ సృష్టించలేకపోయాం. దయచేసి మళ్లీ ప్రయత్నించండి.",
//   "failed_to_initialize_payment": "చెల్లింపును ప్రారంభించడంలో విఫలమైంది. కొద్ది సేపటికి మళ్లీ ప్రయత్నించండి.",
//   "failed_to_open_payment_gateway": "చెల్లింపు విండో తెరవలేకపోయాం. దయచేసి మళ్లీ ప్రయత్నించండి.",

//   // Service Details
//   "birth_chart_analysis": "వ్యక్తిగత జ్యోతిష్య నివేదిక",
//   "complete_kundli_report": " వేద జాతక నివేదిక - జీవితంలోని అన్ని విభాగాలు కవర్",
//   "service_amount": "₹599",

//   // Time of Day Indicators (for emoji display)
//   "morning": "🌅",
//   "afternoon": "☀️",
//   "evening": "🌆",
//   "night": "🌙",

//   // Days of Week
//   "monday": "సోమవారం",
//   "tuesday": "మంగళవారం",
//   "wednesday": "బుధవారం",
//   "thursday": "గురువారం",
//   "friday": "శుక్రవారం",
//   "saturday": "శనివారం",
//   "sunday": "ఆదివారం",

//   // Months (Gregorian)
//   "january": "జనవరి",
//   "february": "ఫిబ్రవరి",
//   "march": "మార్చి",
//   "april": "ఏప్రిల్",
//   "may": "మే",
//   "june": "జూన్",
//   "july": "జూలై",
//   "august": "ఆగస్టు",
//   "september": "సెప్టెంబర్",
//   "october": "అక్టోబర్",
//   "november": "నవంబర్",
//   "december": "డిసెంబర్"
// };
// export default teKundli;
